export default __webpack_public_path__ + "static/media/burgerBuilder.19eb910f.png";